module.exports = __webpack_public_path__ + "img/853cfa2.png";